import { LinearProgress } from '@mui/material';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Stack, Typography } from '@packages/shared';
import { useIntl } from 'react-intl';

const ReviewStatisticFragment = graphql(/* GraphQL */ `
  fragment ReviewStatisticFragment on ReviewStatistic {
    portion
    rating
    count
  }
`);

type ReviewStatisticProps = {
  reviewStatisticData: FragmentType<typeof ReviewStatisticFragment>;
};

export const ReviewStatistic = ({ reviewStatisticData }: ReviewStatisticProps) => {
  const { formatMessage } = useIntl();
  const { rating, portion, count } = getFragmentData(ReviewStatisticFragment, reviewStatisticData);

  return (
    <Stack alignItems="center" gap={1} flexDirection="row">
      <Typography variant="body3" sx={{ width: 60 }}>
        {formatMessage(
          {
            id: 'rating.rating-statistics.label',
            defaultMessage: `{rating, plural, one {# Stern} other {# Sterne}}`,
          },
          { rating },
        )}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={portion}
        color="info"
        sx={{ flexGrow: 1, height: 20, borderRadius: '3px' }}
      />
      <Typography
        variant="body3"
        sx={{ minWidth: 30, textAlign: 'right' }}
      >{`(${count})`}</Typography>
    </Stack>
  );
};
